import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { createHttpParams } from 'src/app/shared/utils/create-http-params.utils';
import { environment } from '../../../environments/environment';

export abstract class BaseService<T> {
  protected resourceUrl: string;
  protected baseUrl: string;
  private dataSource = new BehaviorSubject(null as T);
  currentData = this.dataSource.asObservable();
  changeData(data: T) {
    this.dataSource.next(data);
  }

  constructor(protected http: HttpClient, entityName: string) {
    this.baseUrl = environment.api_url;
    this.resourceUrl = `${environment.api_url}/${entityName}`;
  }

  create(entity: T): Observable<HttpResponse<T>> {
    return this.http.post<T>(`${this.resourceUrl}`, entity, {
      observe: 'response'
    });
  }

  patch(entity: T): Observable<HttpResponse<T>> {
    return this.http.patch<T>(`${this.resourceUrl}`, entity, {
      observe: 'response'
    });
  }

  read(searchValues): Observable<HttpResponse<{ data: T[] }>> {
    const params = createHttpParams(searchValues);

    return this.http.get<{ data: T[] }>(this.resourceUrl, {
      params,
      observe: 'response'
    });
  }

  getData(searchValues?): Observable<HttpResponse<T>> {
    searchValues = searchValues ? searchValues : {};
    const params = createHttpParams(searchValues);

    return this.http.get<T>(this.resourceUrl, {
      params,
      observe: 'response'
    });
  }

  find(id: number | string): Observable<HttpResponse<T>> {
    return this.http.get<T>(`${this.resourceUrl}/${id}`, {
      observe: 'response'
    });
  }

  export(searchValues): Observable<Blob> {
    const params = createHttpParams(searchValues);

    return this.http.get<Blob>(`${this.resourceUrl}/export`, {
      params,
      responseType: 'blob' as 'json'
    });
  }

  update(entity: T, id?: number): Observable<HttpResponse<T>> {
    return this.http.put<T>(
      `${this.resourceUrl}${id ? '/' : ''}${id ? id : ''}`,
      entity,
      {
        observe: 'response'
      }
    );
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, {
      observe: 'response'
    });
  }

  // getShuftiProUrl() {
  //   return this.http.get<any>(`${this.baseUrl}/shuftipro/verification`, {
  //     observe: 'response'
  //   });
  // }

  postShuftiProUrl(body) {
    return this.http.post<any>(`${this.baseUrl}/shuftipro/verification`, body, {
      observe: 'response'
    });
  }

  getShuftiProStus() {
    return this.http.get<any>(`${this.baseUrl}/shuftipro/status`, {
      observe: 'response'
    });
  }
}
